// App store download links
// Update these with the actual URLs once available

export const APP_STORE_URL = 'https://apps.apple.com/us/app/vibes-ai-video-creation/id6757408281'; // iOS App Store
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.facebook.vibes'; // Google Play Store
export const DOWNLOAD_PAGE_URL = '/download'; // Fallback for desktop
